const footringName = ({ selected }) => {
  const { base } = selected || {};
  if (base === "S" || base === "TUH") return "Affixed Footring";
  return "No Footring";
};

export default footringName;
